import { render } from "./cell_toFixed2.vue?vue&type=template&id=5629bb36"
import script from "./cell_toFixed2.vue?vue&type=script&lang=ts"
export * from "./cell_toFixed2.vue?vue&type=script&lang=ts"
script.render = render

export default script